import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const traEn = {
  singup: "Sing up",
  login: "Login",
  header1a: "IR  A  N",
  header1b: " ANCIENT LAND",
  header2:
    "If you are a student, working or passing time, it is important for you This site is right for you, just register",
  getStart: "Get Srart",
  about: "| About IR A N",
  aboutIran:
    " has a rich history, numerous centuries-old ancient cities and magnificent and spectacular historical buildings, as well as diverse and dramatic landscapes of Iran, a pristine and amazing landscape from the mountains to the desert, from the forest to the azure seas, tourists to It amazes.",
  followUs: "Be with us to see these wonders",
  MountDamavand: "Mount Damavand",
  PersianGulf: " Persian Gulf",
  DaryaSarPlain: "Darya Sar Plain",
  QeshmIsland: "Qeshm Island",
  DashtLut: "Dasht-e Lut",
  Bushehrseaport: "Bushehr seaport",
  BushehrseaportAbaut:
    "' Bushehr is a city with many attractions in the south of Iran and on the coast of the Persian Gulf, a port city where maritime trade with India and Africa was very prosperous and many merchants were active there.'",
  PersianArchitecture:
    "This masterpiece is a confirmation of Iranian skill in the two main architectural elements of light and color",
  persianArt: "|Persian Art",
  persianArtTitle:
    "This masterpiece is a confirmation of Iranian skill in the two main architectural elements of light and color",
  hajij: "Hajij Village",
  hajijA: "| About Hajij Village",
  hajijAbout:
    "'Hajij' means green and deep valley and the same name can tell the beauty hidden in this area. Hajij village with its impressive staircase architecture will bring you to a piece of paradise.",
  hajij1: "A unique and memorable view",
  hojij2: "Kind and hospitable people",
  hajij3: "Delicious foods",
  homeMade: "| Iranian handcraft",
  homeMadeTitle:
    "The result of the art of Iranian hands can be the best decoration of your home",
  Enameling: "Enameling",
  EnamelingAbout:
    "Enameling, enameling or enameling is an art that has a history of about five thousand years and is considered a handicraft. Today, in Iran, the center of enamelware production in Isfahan city and prominent masters are engaged in the production of enamel works.",
  carpet: "Carpet Weaving",
  carpetAbout:
    "In the art of Iranian carpet weaving as an art, what has remained far from the opinions is the connection of its creator with the surrounding world, which is manifested in the most immediate and direct way in the works, and has been the concern of the world for a long time.",
  Toreutics: "Toreutics",
  ToreuticsAbout:
    "Toreutics is an original art with special patterns on metals. The history of toreutics dates back to the Aryans, and today Isfahan is considered one of the important centers of toreutics.",
  footer: "Stay with us",
  home: "HOME",
  aboutUS: "ABOUT US",
  theme: "Light Theme",
  theme2: "Dark Theme",
  language: "فارسی",
  language2: "English",
};
const traFr = {
  singup: "ثبت نام",
  login: "ورود",
  header1a: "ایران",
  header1b: "سرزمین کهن",
  header2:
    "اگه شاغلی یا دانشجویی یا حتی دانش آموزی تویی که گذر زمان برات مهمه  این سایت مناسب توعه کافیه ثبت نام کنی",
  getStart: "همین الان شروع کن",
  about: "درباره ایران |",
  aboutIran:
    "  تاریخی غنی ،شهر های باستانی متعدد با چندین قرن قدمت و بناهای تاریخی با شکوه و دیدنی و همچنین مناظر متنوع و داراماتیک ایران ،منظره ای بکر و شگفت انگیزی را از کوه گرفته تا بیابان ،از جنگل گرفته تا دریا های نیلگون ،گردشگران به حیرت وا می دارد",
  followUs: " برای مشاهده این شگفتی ها همراه ما باشید",
  MountDamavand: "قله دماوند",
  PersianGulf: "خلیج فارس",
  DaryaSarPlain: "دشت دریا سر تنکابن",
  QeshmIsland: "جزیره قشم",
  DashtLut: "دشت لوت",
  homeMade: "صنایع دستی ایران |",

  Bushehrseaport: "بندر بوشهر",
  BushehrseaportAbaut:
    "بوشهر شهری با جاذبه‌های دیدنی بسیار در جنوب ایران و حاشیه خلیج فارس است، شهری بندری که زمانی تجارت دریایی با هند و آفریقا در آن رونق بسیار داشت و تاجران زیادی در آن فعالیت داشتند",
  PersianArchitecture:
    " این شاهکار  مهر تاییدی بر مهارت ایرانیان در دو عنصر اصلی معماری  نور و رنگ  است",
  persianArt: "هنر ایرانی |",
  persianArtTitle:
    " این شاهکار  مهر تاییدی بر مهارت ایرانیان در دو عنصر اصلی معماری  نور و رنگ  است",
  hajij: "روستای هجیج",
  hajijA: " درباره روستای هجیج|",
  hajijAbout:
    " هجیج  به معنای دره سرسبز و عمیق است و همین نام می‌تواند گویای زیبایی نهفته در این منطقه باشد.روستای هجیج با معماری پلکانی واعجاب انگیز شما را به قطعه‌ای از بهشت میرساند",
  hajij1: " منظره بی نظیر و به یاد ماندنی",
  hojij2: "مردم مهربان و مهمان نواز",
  hajij3: "غذاهای خوشمزه",
  homeMadeTitle:
    "حاصل هنر دستان ایرانی می تونه به عنوان بهترین شی تزئینی خونت باشه",
  Enameling: "میناکاری",
  EnamelingAbout:
    "میناکاری، میناگری یا میناسازی هنری است که سابقه‌ای در حدود پنج هزار سال دارد و از صنایع دستی محسوب می‌شود.امروزه در ایران کانون تولید ظروف میناکاری شهر اصفهان و استادان برجسته‌ای در تولید آثار مینا مشغول به فعالیت هستند",
  carpet: "قالی بافی",
  carpetAbout:
    "در هنر قالی بافی ایرانی به عنوان یک هنر آنچه از نظرها دور ماند ارتباط خالق آن با جهان پیرامونی می‌باشد که تجلی آن را به بی واسطه‌ترین و مستقیم‌ترین وجه در آثار مشاهده می‌کنیم واز دیر باز مورد توجه جهانیان بوده است",
  Toreutics: "قلم زنی",
  ToreuticsAbout:
    "قلم زنی، هنری اصیل با نقوشی خاص بر روی فلزات است.پیشینه قلم زنی به آریایی ها برمیگردد و امروزه اصفهان از مراکز مهم قلم زنی به شمار می آید",
  footer: "با ما همراه شوید",
  home: "خانه",
  aboutUS: "درباره ما",
  theme: "تم روشن",
  theme2: "تم تاریک",
  language: "فارسی",
  language2: "English",
};

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: traEn },
    fa: { translation: traFr },
  },
  lng: "en",
  fallbackLng: "en",
  debug: true,
  // whiteList : languages,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
